export enum GameItemSize {
  L = 'L',
  M = 'M',
  S = 'S',
  XS = 'XS',
  XXS = 'XXS',
}

export enum ColorMode {
  BLACK_BG = 'black_bg',
  GRAY_BG = 'gray_bg',
  WHITE_BG = 'white_bg',
}
